import React from "react";
import Slider from "react-slick";

const settings = {
  // dots: true,
  infinite: true,
  autoplay: true,
  speed: 500,
  slideToShow: 1,
  slideToScroll: 1,
  swipeToSlide: true
};

const BottomBanner = () => (
  <section id="bottom-banner">
    <div className="text-container">
      <div className="row">
        <div className="twelve columns contact-bottom">
          <h2>Contact Information</h2>
          <h4>
            Alex Payne: 709-634-9705 (Extension 203) <br/>
            Ford Jacobs: 709-632-6207
          </h4>
          <br/>
          <h2>Address</h2>
          <h4>
            3 Herald Avenue <br/>
            Corner Brook, Newfoundland, Canada <br/>
            A2H 4B8 <br/>
          </h4>
        </div>
      </div>
    </div>
  </section>
);

export default BottomBanner;



// WEBPACK FOOTER //
// ./src/components/BottomBanner.js